import { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  CardBody,
} from "reactstrap";
import ApiService from "../../services/apiService";
import { method } from "lodash";
import DateTimePicker from "react-datepicker";
import { toast } from "react-toastify";
import { format } from "date-fns";
import {
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Tooltip,
  ResponsiveContainer,
  Brush,
} from "recharts";
import Select from "react-select";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import { TooltipProps ,Legend} from "recharts";

const Trends = () => {
  const [selectedChaks, setSelectedChaks] = useState<string>("");
  const [trendsData, setTrendsData] = useState<any[]>();
  const [fromDateTime, setFromDateTime] = useState(null);
  const [chakData, setChakData] = useState<any[] | undefined>();
  const [id, setId] = useState<any>();
  const [selectedChakName, setSelectedChakName] = useState<any>();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [toDateTime, setToDateTime] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [trend, setTrend] = useState<string[]>([]);
  const [graphIsVisible, setIsGraphVisible] = useState<string>("");
  const [startIndex, setStartIndex] = useState(0);

  const ROWS_PER_SLIDE = 15;
  const Trends = [
    { name: "Battery" },
    { name: "Pressure" },
    { name: "Temprature" },
    { name: "Volume" },
  ];

  const handleChakChange = (selectedOptions: any) => {
    const selectedIds = selectedOptions?.map((option: any) => option.value);
    const selectedString = selectedIds?.join(",") || "";
    setSelectedChaks(selectedString);
  };

  useEffect(() => {
    setStartIndex(0);
  }, [fromDateTime, toDateTime]);

  const chakOptions = chakData?.map((data) => ({
    label: data.chackName,
    value: data.id,
  }));

  const handleTrend = (name: string, checked: boolean) => {
    setTrend((prev) =>
      checked ? [...prev, name] : prev.filter((item) => item !== name)
    );
  };

  const endIndex = startIndex + ROWS_PER_SLIDE;

  useEffect(() => {
    const getChak = async () => {
      try {
        const response = await ApiService.axiosApi(`/chack`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setChakData(response.data.data);
        } else {
          console.log(
            response.status || response.message || "Unable to get Chak"
          );
        }
      } catch (error) {
        console.log(error);
      }
    };
    getChak();
  }, []);

  const setTrends = () => {
    setIsModalOpen(true);
  };

  const getTrend = async () => {
    try {
      const response = await ApiService.axiosApi(`/trends`, {
        method: "GET",
        params: {
          ChakId: selectedChaks,
          FromDate: fromDateTime
            ? format(fromDateTime, "yyyy-MM-dd HH:mm:ss")
            : undefined,
          ToDate: toDateTime
            ? format(toDateTime, "yyyy-MM-dd HH:mm:ss")
            : undefined,
          Pressure: trend.includes("Pressure") ? true : false,
          Battery: trend.includes("Battery") ? true : false,
          Temprature: trend.includes("Temprature") ? true : false,
          waterMeterVolume: trend.includes("Volume") ? true : false,
        },
      });

      if (response.success) {
        const updatedTrend = response.data.map((trend: any) => ({
          ...trend,
          dateTime: format(new Date(trend.dateTime), "yyyy-MM-dd HH:mm:ss"),
        }));
        setTrendsData(updatedTrend);
        toast.success("Trends Generated");
      } else {
        toast.error(response.data || "Unable To Generate Trends");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (!trendsData || trendsData.length <= ROWS_PER_SLIDE) return;

    const interval = setInterval(() => {
      setStartIndex((prev) => {
        const next = prev + ROWS_PER_SLIDE;
        return next >= trendsData.length ? 0 : next;
      });
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, [trendsData]);

  const visibleData = trendsData?.slice(
    startIndex,
    startIndex + ROWS_PER_SLIDE
  );

  const CustomTooltip = ({
    active,
    payload,
    label,
  }: TooltipProps<any, string>) => {
    if (active && payload && payload.length) {
      const row = payload[0].payload; // this gives the full data object for that point
      return (
        <div
          style={{
            backgroundColor: "white",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <p>
            <strong>{label}</strong>
          </p>
          {row.pressure !== undefined && <p>Pressure: {row.pressure}</p>}
          {row.watermeterVolume !== undefined && (
            <p>Volume: {row.watermeterVolume}</p>
          )}
          {row.extraParameter !== undefined && <p>Chak: {row.chackName}</p>}{" "}
          {/* <-- Not plotted */}
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <Breadcrumbs mainTitle={"Trends"} parent={"trend"} />
      <div className="d-flex px-2 py-2 trend-main">
        <div
          className="bg-light-primary d-flex justify-content-around align-items-center "
          style={{
            width: "100%",
            height: "100px",
            border: "1px solid rgb(43, 94, 94, 0.1)",
          }}
        >
          <div className="d-flex flex-column">
            <Label>Chak:</Label>

            <Select
              isMulti
              options={chakOptions}
              className="basic-multi-select"
              classNamePrefix="select"
              closeMenuOnSelect={false}
              onChange={handleChakChange}
              onMenuClose={() => {
                if (selectedChaks) {
                  setTrends();
                }
              }}
              onMenuOpen={() => {
                setTrend([]);
                setTrendsData([]);
              }}
            />

            {/* <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="custom-dropdown-wrapper">
                            <DropdownToggle
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"

                                style={{
                                    backgroundColor: '#007bff',
                                    borderColor: '#007bff',
                                    color: '#fff',
                                    fontWeight: 500,
                                    borderRadius: '5px',
                                    padding: '8px 16px',
                                    maxWidth: '200px'
                                }}
                                color="primary"
                            >
                                {selectedChakName ? selectedChakName : "Select chak"}
                            </DropdownToggle>

                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{

                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',
                                }}
                            >
                                {chakData?.map((data: any) => (
                                    <DropdownItem onClick={() => {
                                        setId(data.id)
                                        setSelectedChakName(data.chackName)
                                        setTrends();

                                    }} key={data.id}>
                                        {data.chackName}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown> */}
          </div>

          <div className="report-input-div mx-4 input-border d-flex flex-column ">
            <Label>From Date:</Label>
            <DateTimePicker
              className="report-input"
              dateFormat="dd/MM/yyyy HH:mm:ss"
              placeholderText="DD-MM-YYYY"
              showTimeSelect
              onChange={(date: any) => setFromDateTime(date)}
              selected={fromDateTime}
              isClearable
              timeFormat="HH:mm:ss"
            />
          </div>

          <div className="report-input-div mx-4  input-border  d-flex flex-column">
            <Label>To Date:</Label>
            <DateTimePicker
              className="report-input"
              dateFormat="dd/MM/yyyy HH:mm:ss"
              placeholderText="DD-MM-YYYY"
              showTimeSelect
              onChange={(date: any) => setToDateTime(date)}
              selected={toDateTime}
              isClearable
              timeFormat="HH:mm:ss"
            />
          </div>
          <div className="d-flex flex-column">
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
              size="md"
              color="success"
              onClick={() => {
                getTrend();
              }}
            >
              {" "}
              Generate
            </Button>
          </div>
        </div>
      </div>
      <CardBody style={{ overflow: "visible" }} className="p-5 trend-dark">
        <ResponsiveContainer width="100%" height={600}>
          <LineChart data={trendsData}>
            <CartesianGrid stroke="#949292" strokeDasharray="5 5" />

            <XAxis dataKey="dateTime" />

            {trend.includes("Temprature") && (
              <YAxis
                yAxisId="temprature"
                label={{
                  value: "Temperature (°C)",
                  angle: -90,
                  position: "insideLeft",
                  dx: 30,
                  dy: -15,
                }}
                tickFormatter={(v) => `${v}°C`}
              />
            )}

            {/* Y-Axis for Pressure (bar) */}
            {trend.includes("Pressure") && (
              <YAxis
                yAxisId="pressure"
                orientation="right"
                width={50}
                label={{
                  value: "Pressure (bar)",
                  angle: -90,
                  position: "outsideRight",
                  dy: -65,
                }}
                tickFormatter={(v) => `${v} bar`}
              />
            )}

            {/* Y-Axis for Battery (%) */}
            {trend.includes("Battery") && (
              <YAxis
                yAxisId="battery"
                orientation="right"
                label={{
                  value: "Battery (%)",
                  angle: -90,
                  position: "outsideRight",
                  dy: 65,
                }}
                tickFormatter={(v) => `${v}%`}
              />
            )}

            {/* Y-Axis for Volume (L) */}
            {trend.includes("Volume") && (
              <YAxis
                yAxisId="volume"
                orientation="left"
                label={{
                  value: "Volume (m3)",
                  angle: -90,
                  position: "outsideLeft",
                  dy: 65,
                }}
                tickFormatter={(v) => `${v} `}
              />
            )}

            {/* Tooltip (optional) */}

            {/* Trend Lines */}
            {trend.includes("Temprature") && (
              <Line
                yAxisId="temprature"
                type="monotone"
                dataKey="temprature"
                stroke="#2B5F60"
                activeDot={{ r: 6 }}
              />
            )}

            {trend.includes("Battery") && (
              <Line
                yAxisId="battery"
                type="monotone"
                dataKey="battery"
                stroke="#8884d8"
                activeDot={{ r: 6 }}
              />
            )}

            {trend.includes("Pressure") && (
              <Line
                yAxisId="pressure"
                type="monotone"
                dataKey="pressure"
                stroke="#82ca9d"
                activeDot={{ r: 6 }}
              />
            )}

            {trend.includes("Volume") && (
              <Line
                yAxisId="volume"
                type="monotone"
                dataKey="watermeterVolume"
                stroke="#2B5F10"
                activeDot={{ r: 6 }}
              />
            )}

            <Tooltip
              wrapperStyle={{ zIndex: 1000 }}
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #ccc",
              }}
            />
            <Brush
              startIndex={startIndex}
              endIndex={startIndex + ROWS_PER_SLIDE}
              travellerWidth={8}
            />
            <Legend
              verticalAlign="bottom"
              height={36}
              payload={[
                { value: "Pressure", type: "line", color: "#82ca9d" },
                { value: "Volume", type: "line", color: "#2B5F10" },
                { value: "Temperature", type: "line", color: "#2B5F60" }, 
                { value: "Battery", type: "line", color: "#8884d8" }
              ]}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardBody>
      <Modal isOpen={isModalOpen}>
        <ModalHeader>
          <h3> Select Trends</h3>
        </ModalHeader>
        <ModalBody>
          <div className="d-flex align-items-center justify-content-center mx-2 my-4">
            {Trends.map((trend) => (
              <div className=" d-flex align-items-center px-2" key={trend.name}>
                <input
                  type="checkbox"
                  className="native-circle me-2"
                  id={`day-${trend.name}`}
                  onChange={(e) => {
                    handleTrend(trend.name, e.target.checked);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={`day-${trend.name}`}
                >
                  {trend.name}
                </label>
              </div>
            ))}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button onClick={() => setIsModalOpen(false)}>Ok</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Trends;
